// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"withShapes-module--scroll-fix--1r6LZ","wrapper":"withShapes-module--wrapper--3PoNe","shape":"withShapes-module--shape--Vocpl","spark":"withShapes-module--spark--nWaaa"};